export const APP_BASE_DIR = '/employeesettings/';

export const HOST = {
	APIM_BASE_DOMAIN_URL: '#{BaseURL-API}',
	HCM_BASE_DOMAIN_URL: '#{BaseURL-HCM}',
	SECURE_BASE_DOMAIN_URL: '#{BaseURL-Secure}',
	GLOBAL_HEADER_URL: '#{BaseURL-HCM}'
};

export const API_TIME_OUT = '#{ServerCallTimeOut}';
export const APIM_SUBSCRIPTION_KEY = '#{Project-APIm-Key}';
export const isLocal = false;

export const securitySettings = {
	client_id: 'CompanyConfigurationUI',
	redirect_uri: `${HOST.HCM_BASE_DOMAIN_URL}${APP_BASE_DIR}callback.html`,
	response_type: 'token',
	scope: 'companyconfigurationui',
	authority: `${HOST.APIM_BASE_DOMAIN_URL}/sts/v1/common`,
	silent_redirect_uri: `${HOST.HCM_BASE_DOMAIN_URL}${APP_BASE_DIR}callback.html`,
	automaticSilentRenew: true,
	filterProtocolClaims: true,
	loadUserInfo: false,
	includeIdTokenInSilentRenew: false,
	extraQueryParams: { 'subscription-key': APIM_SUBSCRIPTION_KEY }
};
